/**
 * Created by lari on 27/04/2017.
 */
(function () {
    'use strict';
    angular.module('vcexam')
      .component('currentexamsfindings', {
        restrict: 'E',
        bindings: {
          consultid: '<'
        },
        template: `
          <span class="btn btn-info btn-xs"
                ng-show="vm.examinations.length"
                popover-trigger="'outsideClick'"
                uib-popover-template="vm.popover"
                popover-title="Zusammenfassungen der Untersuchungen"
                popover-placement="auto bottom"><i class="fa fa-list-ul"></i></span>
          
          
          <script type="text/ng-template" id="examfindings_popver.tpl.html">
            <div>
              <div ng-repeat="exam in vm.examinations  | filter: {active: true}">
                <h5 ng-bind="exam.template.displayname" style="font-weight: bold"></h5>
                <span ng-show="exam.template.diagnosis.avalues.length > 0" ng-repeat="val in exam.template.diagnosis.avalues">{{val.name}}{{$last ? '' : ', '}}</span>
                <span ng-hide="exam.template.diagnosis.avalues.length > 0"> Keine Zusammenfassung</span>
              </div>
          
          <p class="alert alert-info" style="margin-top: 10pt;">
            Die Untersuchungszusammenfassungen werden automatisch in den Gesamtbefund/Arztbrief übernommen.</p>
            </div>
          </script>
      `,
        controllerAs: 'vm',
        controller: ['$log', 'Rlog', 'Exam', 'vertxEventBusService', '$window',
          function ($log, Rlog, Exam, vertxEventBusService, $window) {
            let vm = this;

            vm.popover = 'examfindings_popver.tpl.html';
            vm.$onInit = function () {
              if (angular.isDefined(vm.consultid)) {
                let query = {consultid: vm.consultid};
                Exam.$search(query).$then(function (exams) {
                  vm.examinations = exams;
                })
              }
            };

            // vm.consultid might be late propagating, get exams on first change
            vm.$onChanges = function (changes) {
              if (!changes.isFirstChange) {
                // if (angular.isDefined(changes.consultid.currentValue)) {
                vm.consultid = changes.consultid.currentValue;
                if (angular.isDefined(vm.consultid)) {
                  Exam.$search({consultid: vm.consultid}).$then(function (exams) {
                    vm.examinations = exams;
                    // $log.debug('******* current exams : ', exams);
                  }, function (err) {
                    $log.error('exam lookup failed in currentexamstherapies for consultid id: ', vm.consultid);
                    Rlog.error('exam', 'currentexamstherapies', 'exam lookup failed', {consultid: vm.consultid});
                  });
                }
              }
            };


            vertxEventBusService.on('examinations.update', function (message) {
              let messages = message.split(':');
              $log.debug('exam update mesg: ', message);
              vm.examinations.$refresh();
            });


          }] // controller
      }); // component

// klammerfriedhof
  }
  ()
)
;